module.exports = __webpack_public_path__ + "06_face.8e3b40d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/06_face.png
// module id = t0Vg
// module chunks = 0